import { classNames } from "../../Utils";

const InputSkeleton = ({ rows, colSpan = 12, className }) => {
  const divElements = Array.from({ length: rows }).map((_, index) => (
    <div
      key={index}
      className={classNames(className, `animate-pulse col-span-${colSpan}`)}
    >
      <div className="flex-1 space-y-2">
        <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
        <div className="block h-10 bg-gray-300 rounded-md"></div>
      </div>
    </div>
  ));

  return <>{divElements}</>;
};

export default InputSkeleton;
